// extracted by mini-css-extract-plugin
export var alignBaseline = "_d-9";
export var alignCenter = "_d-5";
export var alignFlexEnd = "_d-7";
export var alignFlexStart = "_d-6";
export var alignSelfBaseline = "_d-e";
export var alignSelfCenter = "_d-a";
export var alignSelfFlexEnd = "_d-c";
export var alignSelfFlexStart = "_d-b";
export var alignSelfStretch = "_d-d";
export var alignStretch = "_d-8";
export var column = "_d-2";
export var columnReverse = "_d-4";
export var flex = "_d-0";
export var justifyCenter = "_d-f";
export var justifyFlexEnd = "_d-h";
export var justifyFlexStart = "_d-g";
export var justifySpaceAround = "_d-j";
export var justifySpaceBetween = "_d-i";
export var justifySpaceEvenly = "_d-k";
export var row = "_d-1";
export var rowReverse = "_d-3";
export var wrapNowrap = "_d-m";
export var wrapWrap = "_d-l";
export var wrapWrapReverse = "_d-n";